import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import apple from '../../assets/samples/appleColoringSample.png';
import nature from '../../assets/samples/natureColoringSample.png';
import cat from '../../assets/samples/catColoringSample.png';
import shapes from '../../assets/samples/shapesColoringSample.png';
import city from '../../assets/samples/cityColoringSample.png';
import factory from '../../assets/samples/factoryColoringSample.png';
import anatomy from '../../assets/samples/anatomyColoringSample.png';
import map from '../../assets/samples/mapColoringSample.png';
import pt from '../../assets/samples/ptColoringSample.png';
import lab from '../../assets/samples/labColoringSample.png';
import car from '../../assets/samples/carColoringSample.png';
import doll from '../../assets/samples/dollColoringSample.png';
import tictactoe from '../../assets/samples/ticTacToeSample.png';
import maze1 from '../../assets/samples/maze1Sample.png';
import matchingColors1 from '../../assets/samples/matchingColors1Sample.png';
import ball from '../../assets/samples/ballColoringSample.png';


const PaintCanvas = ({ width = 360, height = 360, imageSrc, onClose }) => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const userId = authState.user._id
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [drawColor, setDrawColor] = useState('#000000');
  const [lineWidth, setLineWidth] = useState(1);
  const colors = ['#FF0000', '#FF7F00', '#FFFF00', '#00FF00', '#0000FF', '#4B0082', '#8B00FF', '#000000', '#FFFFFF', '#808080'];
  const penLines = [1,2,3,4,5,10];

  // console.log("imageSrc: ",imageSrc);

  const imageSources = {
    apple: apple,
    nature: nature,
    cat: cat,
    shapes: shapes,
    city: city,
    factory: factory,
    anatomy: anatomy,
    map: map,
    pt: pt,
    lab: lab,
    car: car,
    doll: doll,
    tictactoe: tictactoe,
    maze1: maze1,
    matchingColors1: matchingColors1,
    ball: ball
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const image = new Image();
    image.src = imageSources[imageSrc];
    image.onload = () => {
      ctx.clearRect(0, 0, width, height); 
      ctx.drawImage(image, 0, 0, width, height); 
    };
    ctx.strokeStyle = 'black'; 
    ctx.lineWidth = 1;

  }, [imageSrc, width, height]);

  // Update canvas stroke color when drawColor changes
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.strokeStyle = drawColor;
  }, [drawColor]);

  // Update canvas lineWidth when changes
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.lineWidth = lineWidth;
  }, [lineWidth]);


  // Handle mouse and touch events
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const startDrawing = (x, y) => {
      ctx.beginPath();
      ctx.moveTo(x, y);
      setIsDrawing(true);
    };

    const draw = (x, y) => {
      if (!isDrawing) return;
      ctx.lineTo(x, y);
      ctx.stroke();
    };

    const endDrawing = () => {
      if (isDrawing) {
        setIsDrawing(false);
        ctx.beginPath(); 
      }
    };

    // Mouse Events
    const handleMouseDown = (e) => {
      const rect = canvas.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;
      startDrawing(offsetX, offsetY);
    };

    const handleMouseMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;
      draw(offsetX, offsetY);
    };

    const handleMouseUp = endDrawing;
    const handleMouseOut = endDrawing;

    // Touch Events
    const handleTouchStart = (e) => {
      e.preventDefault();
      const rect = canvas.getBoundingClientRect();
      const offsetX = e.touches[0].clientX - rect.left;
      const offsetY = e.touches[0].clientY - rect.top;
      startDrawing(offsetX, offsetY);
    };

    const handleTouchMove = (e) => {
      e.preventDefault();
      const rect = canvas.getBoundingClientRect();
      const offsetX = e.touches[0].clientX - rect.left;
      const offsetY = e.touches[0].clientY - rect.top;
      draw(offsetX, offsetY);
    };

    const handleTouchEnd = endDrawing;

    // Add event listeners for mouse and touch
    canvas.addEventListener('mousedown', handleMouseDown);
    canvas.addEventListener('mousemove', handleMouseMove);
    canvas.addEventListener('mouseup', handleMouseUp);
    canvas.addEventListener('mouseout', handleMouseOut);

    canvas.addEventListener('touchstart', handleTouchStart);
    canvas.addEventListener('touchmove', handleTouchMove);
    canvas.addEventListener('touchend', handleTouchEnd);

    return () => {
      // Remove event listeners for mouse and touch
      canvas.removeEventListener('mousedown', handleMouseDown);
      canvas.removeEventListener('mousemove', handleMouseMove);
      canvas.removeEventListener('mouseup', handleMouseUp);
      canvas.removeEventListener('mouseout', handleMouseOut);

      canvas.removeEventListener('touchstart', handleTouchStart);
      canvas.removeEventListener('touchmove', handleTouchMove);
      canvas.removeEventListener('touchend', handleTouchEnd);
    };
  }, [isDrawing]);

  const handleUploadImage = async () => {
    const canvas = canvasRef.current;
    if (canvas) {
      const dataURL = canvas.toDataURL('image/png');
      const response = await fetch(dataURL);
      const blob = await response.blob();
      const formData = new FormData();
      formData.append('image', blob, 'canvas-image.png');
      await axios.post('http://localhost:5000/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert('Image uploaded successfully!');
    }
  };

  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, width, height);
  };

  const handleColorSelect = (color) => {
    setDrawColor(color);
  };

  const handlePenSelect = (width) => {
    setLineWidth(width);
  };

  return (
    <div className="ml-5 mr-5" style={{ marginTop: '300px', position: 'relative', backgroundColor: '#000000', opacity: 1 }}>
      <div className='flex flex-row justify-center my-4 mt-4'>
        <div className='flex flex-row justify-center'>
          <div className='h-30 grid grid-cols-3 grid-rows-2 gap-x-2 gap-y-1 justify-center my-1 p-1' style={{ backgroundColor: '#E6F7FF', opacity: 1 }}>
            {penLines.map((width, index) => (
              <button
                key={index}
                onClick={() => handlePenSelect(width)}
                style={{
                  width: `${width * 3}px`,
                  height: `${width * 3}px`,
                  backgroundColor: 'blue',  
                  borderRadius: '50%',
                  border: '1px solid black',
                  display: 'block',
                  margin: 'auto',
                }}
              >
                <div
                  style={{
                    width: `${width * 2}px`,
                    height: `${width * 2}px`,
                    backgroundColor: 'white',
                    borderRadius: '50%',
                  }}
                ></div>
              </button>
            ))}
          </div>
          {/* Color selection */}
          <div className='h-30 grid grid-cols-5 grid-rows-2 gap-x-2 gap-y-1 justify-center my-1 p-1 border' style={{ backgroundColor: '#E6E6E6', opacity: 1 }}>
            {colors.map((color, index) => (
              <button
                key={index}
                style={{ backgroundColor: color }}
                className='w-5 h-5 rounded-full mx-2 border border-black'
                onClick={() => handleColorSelect(color)}
              />
            ))}
          </div>
        </div>
      </div>
      <div className='flex flex-row justify-center mb-4'>
        <Link to={"/orderflow-products"}>
          <div className='bg-blue-500 text-white p-4 rounded-lg shadow-md hover:bg-blue-600 transition duration-300 flex flex-row justify-center'>
            <i className='fas fa-pen-nib text-2xl mr-3 text-yellow-300'></i>
            <h1 className='text-lg font-semibold'>
              Use Kids Friendly <strong className='text-orange-700'>Thinky Stylus</strong> for the best coloring experience
            </h1>
          </div>
        </Link>
      </div>
      <div className='flex flex-row'>
        <canvas
          ref={canvasRef}
          width={width}
          height={height}
          style={{
            border: '1px solid #ccc',
            backgroundColor: 'white',
            display: 'block',
            margin: '0 auto',
            overflowY: 'auto',
          }}
          className="canvas"
        />
      </div>
      <div className='flex flex-row'>
        <button onClick={clearCanvas}>Clear</button>
        <button onClick={handleUploadImage}>Save Image</button>
        <button onClick={onClose}>Close</button>
      </div>
      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

export default PaintCanvas;
